module.exports = __webpack_public_path__ + "static/media/daisyChainSecondScreen.52b07fdc.png";